import "./less/index.scss";

import ReactDOM from "react-dom/client";
import App from "./App";
import PathProvider from "./libs/path/PathProvider";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import FoodApi from "./data/FoodApi";
import Usernames from "./libs/login/Usernames";
import OverlayProvider from "./gui/Overlay/OverlayProvider";
import LoginProvider from "./gui/Login/LoginProvider";
import SnackbarProvider from "./gui/Snackbar/SnackbarProvider";
import FoodProvider from "./utils/FoodProvider";
import AuthProvider from "./gui/Login/AuthProvider";

(async function main(){
  const root = ReactDOM.createRoot(document.getElementById("root")!);

  await FoodApi.i.init().auth()
  Usernames.i.init(FoodApi.i)

  root.render(<AuthProvider api={FoodApi.i}><PathProvider><SnackbarProvider><OverlayProvider><FoodProvider>
    <LoginProvider api={FoodApi.i} required={false}>
      <App/>
    </LoginProvider>
    </FoodProvider></OverlayProvider></SnackbarProvider></PathProvider></AuthProvider>);

  serviceWorkerRegistration.register()
})()
